import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import Initiatives from '../components/Initiatives';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";

export default function Events() {
    return (
        <>
            <Navbar />
            <PageHeader title="SERMONS" path="" name="" />
            <Initiatives />
            <Footer />
            <BackToTop />
        </>
    );
}